import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StateState } from './state.state'

// export const selectStateState = (state: StateState) => state

// export const selectAllStates = createSelector(selectStateState, state => state.states)

export const selectStateState = createFeatureSelector<StateState>('state')

export const selectAllStates = createSelector(selectStateState, (state: StateState) => state.states)
